class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.loadMore.bind(this));
  }

  async loadMore() {
    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl || this.button.disabled) return;

    this.button.setAttribute('disabled', 'disabled');
    this.button.classList.add('loading');

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = html.querySelector('#product-grid');
      const currentGrid = document.querySelector('#product-grid');

      if (!newGrid || !currentGrid) throw new Error('Grid not found in response');

      // Append the new product items
      Array.from(newGrid.children).forEach((item) => {
        currentGrid.appendChild(item);
      });

      // Find the load-more-button in the fetched response
      const newButton = html.querySelector('load-more-button');
      if (newButton && newButton.dataset.nextUrl) {
        // Update this button's next URL
        this.dataset.nextUrl = newButton.dataset.nextUrl;
        this.button.removeAttribute('disabled');
        this.button.classList.remove('loading');

        // Re-observe newly added cards for scroll animations
        if (window.Shopify && Shopify.designMode === false) {
          const cards = currentGrid.querySelectorAll('.scroll-trigger:not(.scroll-trigger--offscreen)');
          if (typeof theme !== 'undefined' && theme.reveal) {
            cards.forEach((c) => theme.reveal(c));
          }
        }
      } else {
        // No more pages — remove the button entirely
        this.remove();
      }
    } catch (error) {
      console.error('Load more failed:', error);
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
      // Optionally show a retry message
      this.button.textContent = 'Try again';
    }
  }
}

customElements.define('load-more-button', LoadMoreButton);